import React from 'react';

const Logo = ({ className = "h-10 w-auto" }) => {
  return (
    <img
      src="/cbn-logo.png"
      alt="Career Branding Network"
      className={`${className} object-contain`}
    />
  );
};

export default Logo;
